module.exports = __webpack_public_path__ + "media/images/landing_page/2023/main_home_image_mob-19f431edaad13a70cf40786a1645c2c9.webp";